









































import Vue from "vue";
import { TheTeam } from "@/models/the-team";
import TeamService from "@/services/getTeams";
// import { uuid } from 'vue-uuid';
import { getUser } from "@/utils/getUser";

export default Vue.extend({
  data() {
    return {
      personList: [] as TheTeam[],
      isLoaded: false
    };
  },
  async created() {
    this.isLoaded = true
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const teamService = new TeamService(jwt);
      const response = await teamService.getTeams();

      if (response && response.status == 200) {
        if (response.data) {
          response.data.forEach(element => {
            if(!element.isCustomer) {
              if (!element.imgurl) {
                element.imgurl = require('@/assets/img/the-team/default.jpeg')
              }
              this.personList.push(element);
            }
          });
        }
      }
    }
    this.isLoaded = false;

  }
});
